import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-crypto-tab',
  templateUrl: './crypto-tab.component.html',
  styleUrls: ['./crypto-tab.component.scss'],
})
export class CryptoTabComponent implements OnInit {
  currency = 1;

  constructor(public router: Router, private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('TiendaCrypto | Mercado');
  }

  isExchangeActive() {
    if (
      this.router.url === '/core/crypto-exchange' ||
      this.router.url === '/core/crypto-exchange?confirmedTx=true'
    ) {
      return true;
    }
    return false;
  }
}
